import { CommentOutlined } from '@ant-design/icons'
import { Badge, Button, Segmented, Tooltip } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'

import {
  type CommentFilterMode,
  type CommentViewMode,
  useCommentCount,
  useComments,
} from './CommentsProvider'

export const CommentSidebarToggle: FC = () => {
  const {
    isSidebarVisible,
    toggleSidebar,
    viewMode,
    setViewMode,
    filterMode,
    setFilterMode,
  } = useComments()
  const unresolvedCount = useCommentCount()

  return (
    <ToggleRow>
      {isSidebarVisible && (
        <>
          <Segmented
            value={viewMode}
            options={[
              { label: 'This step', value: 'current-step' as CommentViewMode },
              { label: 'All steps', value: 'all-steps' as CommentViewMode },
            ]}
            onChange={(val) => setViewMode(val as CommentViewMode)}
            size='small'
          />
          {viewMode === 'all-steps' && (
            <Segmented
              value={filterMode}
              options={[
                { label: 'Active', value: 'active' as CommentFilterMode },
                { label: 'Resolved', value: 'resolved' as CommentFilterMode },
              ]}
              onChange={(val) => setFilterMode(val as CommentFilterMode)}
              size='small'
            />
          )}
        </>
      )}
      <Tooltip title={isSidebarVisible ? 'Hide comments' : 'Show comments'}>
        <Badge count={unresolvedCount} size='small' offset={[-4, 4]}>
          <Button
            type={isSidebarVisible ? 'primary' : 'text'}
            icon={<CommentOutlined />}
            onClick={toggleSidebar}
          />
        </Badge>
      </Tooltip>
    </ToggleRow>
  )
}

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`
